import React, { useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import IconCashCard from '../assets/icons/IconCashCard'
import IconCashActive from '../assets/icons/IconCashActive'
import DynamicColor from '../components/common/dynamic-color'
import ModalForm from '../components/common/modal-form'
import PaymentMethodGroup from '../components/common/PaymentMethodGroup'
import paypalButtonScript from '../components/elements/PaypalButton'
import { COLOR_NAME, PAYMENT_METHOD, StorageKeys } from '../constants'
import { paymentMethodsSupport as paymentMethodsSupportSelector } from '../selectors/restaurant'
import { disableBrowserBack } from '../utils/helper'

const ModalPayment = ({
    showPaymentPaypal,
    orderSuccessData,
    paypalClientId,
    handleApprove,
    paypalCurrentcyCode,
    handlePayOther,
    // orderMethod,
}) => {
    const { t } = useTranslation()
    const paymentMethodsSupport = useSelector(paymentMethodsSupportSelector)
    const hasPaymentMethodCash = paymentMethodsSupport.some(pmt => [ PAYMENT_METHOD.CASH, PAYMENT_METHOD.CASH_CARD ].includes(pmt))
    const isOpen = showPaymentPaypal && !!orderSuccessData

    const PaypalButton = useMemo(
        () => paypalButtonScript(paypalClientId, paypalCurrentcyCode),
        [paypalClientId, paypalCurrentcyCode]
    )

    useEffect(() => {
        isOpen && disableBrowserBack()
        let lastInnerHeight
        isOpen && (lastInnerHeight = window.innerHeight)

        return () => {
            if (lastInnerHeight) {
                window.sessionStorage.setItem(StorageKeys.lastInnerHeight, lastInnerHeight)
            }
        }
    }, [ isOpen ]);

    return (
        <ModalForm
            rootClass="modal-payment"
            isOpen={isOpen}
            centered
        >
            <DynamicColor
                style={{ color: COLOR_NAME.MODAL_TEXT }}
                className="heading-5 text-center mb-8"
            >
                {t('modalPayWithPaypal.title')}
            </DynamicColor>

            {!!paypalClientId && (
                <PaypalButton
                    client={{
                        sandbox: paypalClientId,
                        production: paypalClientId,
                    }}
                    createOrder={() => orderSuccessData.paypalInfo.id}
                    onApprove={handleApprove}
                    currency={paypalCurrentcyCode}
                    style={{
                        color: 'silver',
                    }}
                    onError={error => console.log({ error })}
                />
            )}

            {hasPaymentMethodCash && (
                <PaymentMethodGroup
                    name="paymentMethod"
                    className="mt-2"
                    onChange={({ target: { value } }) => handlePayOther(value)}
                    list={[
                        {
                            label: t('customerInfo.paymentMethodGroupCash'),
                            options: [
                                paymentMethodsSupport.includes(PAYMENT_METHOD.CASH) && {
                                    widthIcon: true,
                                    label: t('customerInfo.cash'),
                                    value: PAYMENT_METHOD.CASH,
                                    icon: IconCashActive,
                                    unCheckClass: 'payment-type-uncheck',
                                },
                                paymentMethodsSupport.includes(PAYMENT_METHOD.CASH_CARD) && {
                                    widthIcon: true,
                                    label: t('customerInfo.cash_card'),
                                    value: PAYMENT_METHOD.CASH_CARD,
                                    icon: IconCashCard,
                                    unCheckClass: 'payment-type-uncheck',
                                },
                            ].filter(Boolean),
                        },
                    ].filter(g => !!g.options.length)}
                />
            )}
        </ModalForm>
    )
}

export default ModalPayment
